/**
 * Custom error class for API-related errors
 * Provides structured information about the API error
 */
export class ApiError extends Error {
  public readonly status: number
  public readonly statusText: string
  public readonly url: string
  public readonly method: string
  public readonly body: unknown

  constructor({
    message,
    status,
    statusText,
    url,
    body,
    method
  }: {
    message: string
    status: number
    statusText: string
    url: string
    body: unknown
    method: string
  }) {
    super(message)
    this.name = "ApiError"
    this.status = status
    this.statusText = statusText
    this.url = url
    this.body = body
    this.method = method

    // This is needed to make instanceof work correctly with TypeScript
    Object.setPrototypeOf(this, ApiError.prototype)
  }

  /** @deprecated Use `body` instead. Returns JSON-serialized body for backwards compatibility. */
  get responseBody(): string {
    if (this.body === undefined || this.body === null) {
      return ""
    }
    if (typeof this.body === "string") {
      return this.body
    }
    return JSON.stringify(this.body)
  }
}
